import { trackCopy } from '../../analytics/posthog'
import { useT } from '../../i18n/useT'

interface CopyButtonProps {
  text: string
  onCopied: () => void
}

export function CopyButton({ text, onCopied }: CopyButtonProps) {
  const t = useT()
  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(text)
      trackCopy()
      onCopied()
    } catch {
      // Fallback
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      trackCopy()
      onCopied()
    }
  }

  return (
    <button
      onClick={handleCopy}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-text-secondary hover:text-text rounded-lg hover:bg-surface-hover transition-colors"
      title={t('result.copyTitle')}
    >
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
      {t('result.copy')}
    </button>
  )
}
